import React from "react"
import cn from "classnames"
import env from "@/common/env"

const NativeCheckbox: React.FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = props => <input type="checkbox" {...props} />

const Checkbox: React.FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = props => (
  <div
    className={cn("checkbox", { checked: props.checked, disabled: props.disabled })}
    onClick={() => !props.disabled && props.onChange && props.onChange({} as React.ChangeEvent<HTMLInputElement>)}
  >
    <input type="checkbox" {...props} />
    <label htmlFor={props.id} className="checkbox-label"></label>
  </div>
)

export default env.TEST ? NativeCheckbox : Checkbox
